
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/post/[slugPost]",
      function () {
        return require("private-next-pages/post/[slugPost].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/post/[slugPost]"])
      });
    }
  